import * as Tools from "../utils/tools";
import * as Dialog from "../utils/dialog";
import * as Cache from "../utils/cache";
import * as Jump from "../utils/jump";
import store from "../../store/index";

let Auth = {
    /**
     * 检查是否登录
     */
    checkLogin() {
        let token = Cache.get('token');
        let userInfo = Cache.get('userInfo');
        if (Tools.empty(token) || Tools.empty(userInfo)) {
            Dialog.toast('请先登录');
            Auth.logout();
            return false;
        } else {
            return true;
        }
    },
    /**
     * 退出登录
     */
    logout: function () {
        store.commit('setToken', '');
        store.commit('setUserInfo', {});
        store.commit('setShowLogin', true);
        Jump.href('/');
    }
};

export default Auth